import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await axios.get(`${API}/products/${slug}`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const verifyAdmin = async (token) => {
  const { data } = await axios.post(
    `${API}/admin/verify`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const fetchAdminSubmissions = async (token) => {
  const { data } = await axios.get(`${API}/admin/contact-submissions`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};
